const glazyDoubleGlassTypes = ['glass', 'specialglazyglass'];

export default glazyDoubleGlassTypes;
